<div class="row" style="width: 100%; margin: 0 auto;">
  <div class="col-12">
    <mdb-card>
      <mdb-card-header class="bg-white">
        <div class="headerCover">
          <div class="headerTilte app_list_header">
            <h5 class="m-0" class="mainHeadingStyle">Purchase request</h5>
          </div>
          <div class="headerButtons">
            <img *ngIf="saveFlag" src="../../../assets/ui_icons/buttons/save_button.svg" class="saveimgbtn_inpatinfo"
              (click)="requestSave()" alt="">
          </div>
        </div>
      </mdb-card-header>
      <mdb-card-body>
        <div class="cover_div" style="padding-bottom: 13px;">
          <div class="content_cover">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <mat-label class="matlabel">Location<br>
                  <select disableOptionCentering class="ipcss widthappt" [(ngModel)]="pharmacyLocation">
                    <option *ngFor="let loc of pharmacyLocationArray" value={{loc.location}}>{{loc.location}}
                    </option>
                  </select>
                </mat-label>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <mat-label class="matlabel">Supplier<br>
                  <input type="text" class="ipcss widthappt" required maxlength="50" (keyup)="getVendor()"
                    maxlength="50" [(ngModel)]="vendor" matInput [matAutocomplete]="auto1" />
                  <mat-autocomplete #auto1="matAutocomplete">
                    <mat-option (click)="selected_vendor(vendor)" *ngFor="let vendor of pharmacyVendorArray" value={{vendor.name}}>
                      {{vendor.name}}
                    </mat-option>
                  </mat-autocomplete>

                  <!-- <select disableOptionCentering class="ipcss widthappt" [(ngModel)]="vendor">
                    <option *ngFor="let vendor of pharmacyVendorArray" value={{vendor.name}}>{{vendor.name}}
                    </option>
                  </select> -->
                </mat-label>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <mat-label class="matlabel">Product type<br>
                  <select disableOptionCentering class="ipcss widthappt" [(ngModel)]="productType">
                    <option *ngFor="let pro_type of productTypeList" value={{pro_type.med_code}}>
                      {{pro_type.med_name}}</option>
                  </select>
                </mat-label>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <mat-label class="matlabel">Product name<br>
                  <input type="text" class="ipcss widthappt" required maxlength="50" (keyup)="getProductDetails()"
                    maxlength="50" [(ngModel)]="productName" matInput [matAutocomplete]="auto" />
                  <mat-autocomplete #auto="matAutocomplete">
                    <mat-option (click)="getProductName(prod)" *ngFor="let prod of productArray" value={{prod.name}}>
                      {{prod.name}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-label>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <mat-label class="matlabel">UOM
                  <input matInput class="ipcss widthappt" [(ngModel)]="uom" type="text" disabled="true">
                </mat-label>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <mat-label class="matlabel">Quantity
                  <input matInput class="ipcss widthappt" [(ngModel)]="quantity" required maxlength="5" type="text">
                </mat-label>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <mat-label>
                  <img src="../../../assets/ui_icons/buttons/add_button.svg" (click)="purchaseRequest()"
                    class="saveimgbtn_inpatinfo " style="margin: 20px 0;">
                </mat-label>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-12 col-sm-12 col-xl-12 col-lg-12">
            <table *ngIf="purchaseReq.length" mdbTable datatable [dtOptions]="dtOptions"
              class="table table-nowrap table-sm dataTable billcreae_table">
              <thead class="tableheading">
                <tr>
                  <th>Vendor</th>
                  <th>Product</th>
                  <th>Location</th>
                  <th>Quantity</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let person of purchaseReq  let i = index" class="tdvalues">
                  <td style="text-align: left !important;">{{person.mfg_name}}</td>
                  <td style="text-align: left !important;">{{person.product_name}}</td>
                  <td>{{person.loc_txt}} </td>
                  <td>{{person.quantity}}</td>
                  <td>
                    <img class="deleteimg" (click)="edit(i)" src="../../../assets/ui_icons/buttons/trash_icon.svg" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </mdb-card-body>
    </mdb-card>
  </div>
</div>